import React from 'react'
import { Label } from 'semantic-ui-react'

const yellow = '#ffe445'

export default ({ children, ...props }) => <Label size='big' style={{ color: yellow }} {...props}>{children}</Label>


// WEBPACK FOOTER //
// ./src/components/ScoreLabel.js